import type { LucideIcon } from "lucide-react";
import {
  AlarmPlus,
  ArrowDown,
  ArrowDownLeft,
  ArrowDownRight,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  ArrowUpRight,
  Award,
  Baby,
  BadgeAlert,
  BadgeCheck,
  BadgeHelp,
  BadgeInfo,
  Ban,
  Banknote,
  Bell,
  BellOff,
  BellRing,
  Bold,
  Bolt,
  Book,
  BookOpen,
  Bookmark,
  Bot,
  BrainCircuit,
  Briefcase,
  BriefcaseBusiness,
  Building,
  Building2,
  Cake,
  Calendar,
  CalendarCheck,
  CalendarDays,
  CalendarPlus,
  CalendarRange,
  CalendarX,
  Camera,
  ChartColumn,
  ChartGantt,
  ChartLine,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDollarSign,
  CircleDot,
  CircleHelp,
  CircleMinus,
  CirclePause,
  CirclePlus,
  CircleUser,
  CircleUserRound,
  CircleX,
  Clipboard,
  ClipboardCheck,
  ClipboardCopy,
  ClipboardList,
  ClipboardPaste,
  Clock3,
  Cloud,
  CloudDownload,
  CloudMoon,
  CloudSun,
  CloudUpload,
  Code,
  Cog,
  Coins,
  Columns,
  Columns3,
  Copy,
  CreditCard,
  Cross,
  Crown,
  Database,
  Dices,
  DollarSign,
  Download,
  Edit,
  Ellipsis,
  EllipsisVertical,
  Expand,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileArchive,
  FileAudio,
  FileBarChart,
  FileCheck,
  FileCode,
  FileImage,
  FileMinus,
  FilePen,
  FilePenLine,
  FilePlus,
  FileQuestion,
  FileSearch,
  FileSpreadsheet,
  FileText,
  FileUser,
  FileVideo,
  Files,
  Filter,
  FilterX,
  Flag,
  FlagTriangleRight,
  Gift,
  GitBranch,
  Github,
  Globe,
  GraduationCap,
  Grid,
  Grip,
  GripHorizontal,
  GripVertical,
  HandCoins,
  Heart,
  History,
  Home,
  Hourglass,
  IdCard,
  Image,
  ImageDown,
  ImageUp,
  Inbox,
  Info,
  Instagram,
  Italic,
  Key,
  KeyRound,
  Keyboard,
  Layers3,
  LayoutGrid,
  LayoutList,
  Leaf,
  LeafyGreen,
  LifeBuoy,
  Lightbulb,
  Link,
  Link2Off,
  Linkedin,
  List,
  ListChecks,
  LoaderCircle,
  Lock,
  LogIn,
  LogOut,
  MailOpen,
  MapPin,
  Medal,
  Menu,
  MessageCircleMore,
  MessageCircleQuestion,
  MessageSquareMore,
  MessageSquareText,
  MessagesSquare,
  MicOff,
  Minus,
  Moon,
  Network,
  Newspaper,
  Paperclip,
  Pen,
  PenLine,
  Pencil,
  Phone,
  PhoneOff,
  PieChart,
  Plane,
  Play,
  PlayCircle,
  Plus,
  Presentation,
  Radar,
  Redo,
  RefreshCw,
  Reply,
  ReplyAll,
  Rocket,
  Save,
  ScrollText,
  Search,
  Send,
  Share,
  Share2,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Signal,
  SlidersHorizontal,
  Smile,
  Sparkles,
  Square,
  SquareCheck,
  SquareCheckBig,
  SquareCode,
  SquareMinus,
  SquarePen,
  SquarePlus,
  SquareX,
  Star,
  StarHalf,
  Stethoscope,
  StickyNote,
  Store,
  Sun,
  Table,
  Tag,
  Tags,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  Trash,
  Trash2,
  TriangleAlert,
  Trophy,
  Truck,
  Underline,
  Undo,
  University,
  Upload,
  User,
  UserCheck,
  UserCog,
  UserPen,
  UserRoundCog,
  UserRoundMinus,
  UserRoundPlus,
  UserRoundX,
  Users,
  Video,
  VideoOff,
  Wallet,
  WandSparkles,
  Wifi,
  X,
  ZoomIn,
  ZoomOut
} from "lucide-react";

export const STATIC_LUCIDE_ICONS: Record<string, LucideIcon> = {
  "alarm-plus": AlarmPlus,
  "arrow-down": ArrowDown,
  "arrow-down-left": ArrowDownLeft,
  "arrow-down-right": ArrowDownRight,
  "arrow-left": ArrowLeft,
  "arrow-left-right": ArrowLeftRight,
  "arrow-right": ArrowRight,
  "arrow-up": ArrowUp,
  "arrow-up-down": ArrowUpDown,
  "arrow-up-right": ArrowUpRight,
  "award": Award,
  "baby": Baby,
  "badge-alert": BadgeAlert,
  "badge-check": BadgeCheck,
  "badge-help": BadgeHelp,
  "badge-info": BadgeInfo,
  "ban": Ban,
  "banknote": Banknote,
  "bell": Bell,
  "bell-off": BellOff,
  "bell-ring": BellRing,
  "bold": Bold,
  "bolt": Bolt,
  "book": Book,
  "book-open": BookOpen,
  "bookmark": Bookmark,
  "bot": Bot,
  "brain-circuit": BrainCircuit,
  "briefcase": Briefcase,
  "briefcase-business": BriefcaseBusiness,
  "building": Building,
  "building-2": Building2,
  "cake": Cake,
  "calendar": Calendar,
  "calendar-check": CalendarCheck,
  "calendar-days": CalendarDays,
  "calendar-plus": CalendarPlus,
  "calendar-range": CalendarRange,
  "calendar-x": CalendarX,
  "camera": Camera,
  "chart-column": ChartColumn,
  "chart-gantt": ChartGantt,
  "chart-line": ChartLine,
  "check": Check,
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "chevron-up": ChevronUp,
  "circle": Circle,
  "circle-alert": CircleAlert,
  "circle-check": CircleCheck,
  "circle-dollar-sign": CircleDollarSign,
  "circle-dot": CircleDot,
  "circle-help": CircleHelp,
  "circle-minus": CircleMinus,
  "circle-pause": CirclePause,
  "circle-plus": CirclePlus,
  "circle-user": CircleUser,
  "circle-user-round": CircleUserRound,
  "circle-x": CircleX,
  "clipboard": Clipboard,
  "clipboard-check": ClipboardCheck,
  "clipboard-copy": ClipboardCopy,
  "clipboard-list": ClipboardList,
  "clipboard-paste": ClipboardPaste,
  "clock-3": Clock3,
  "cloud": Cloud,
  "cloud-download": CloudDownload,
  "cloud-moon": CloudMoon,
  "cloud-sun": CloudSun,
  "cloud-upload": CloudUpload,
  "code": Code,
  "cog": Cog,
  "coins": Coins,
  "columns": Columns,
  "columns-3": Columns3,
  "copy": Copy,
  "credit-card": CreditCard,
  "cross": Cross,
  "crown": Crown,
  "database": Database,
  "dices": Dices,
  "dollar-sign": DollarSign,
  "download": Download,
  "edit": Edit,
  "ellipsis": Ellipsis,
  "ellipsis-vertical": EllipsisVertical,
  "expand": Expand,
  "external-link": ExternalLink,
  "eye": Eye,
  "eye-off": EyeOff,
  "file": File,
  "file-archive": FileArchive,
  "file-audio": FileAudio,
  "file-bar-chart": FileBarChart,
  "file-check": FileCheck,
  "file-code": FileCode,
  "file-image": FileImage,
  "file-minus": FileMinus,
  "file-pen": FilePen,
  "file-pen-line": FilePenLine,
  "file-plus": FilePlus,
  "file-question": FileQuestion,
  "file-search": FileSearch,
  "file-spreadsheet": FileSpreadsheet,
  "file-text": FileText,
  "file-user": FileUser,
  "file-video": FileVideo,
  "files": Files,
  "filter": Filter,
  "filter-x": FilterX,
  "flag": Flag,
  "flag-triangle-right": FlagTriangleRight,
  "gift": Gift,
  "git-branch": GitBranch,
  "github": Github,
  "globe": Globe,
  "graduation-cap": GraduationCap,
  "grid": Grid,
  "grip": Grip,
  "grip-horizontal": GripHorizontal,
  "grip-vertical": GripVertical,
  "hand-coins": HandCoins,
  "heart": Heart,
  "history": History,
  "home": Home,
  "hourglass": Hourglass,
  "id-card": IdCard,
  "image": Image,
  "image-down": ImageDown,
  "image-up": ImageUp,
  "inbox": Inbox,
  "info": Info,
  "instagram": Instagram,
  "italic": Italic,
  "key": Key,
  "key-round": KeyRound,
  "keyboard": Keyboard,
  "layers-3": Layers3,
  "layout-grid": LayoutGrid,
  "layout-list": LayoutList,
  "leaf": Leaf,
  "leafy-green": LeafyGreen,
  "life-buoy": LifeBuoy,
  "lightbulb": Lightbulb,
  "link": Link,
  "link-2-off": Link2Off,
  "linkedin": Linkedin,
  "list": List,
  "list-checks": ListChecks,
  "loader-circle": LoaderCircle,
  "lock": Lock,
  "log-in": LogIn,
  "log-out": LogOut,
  "mail-open": MailOpen,
  "map-pin": MapPin,
  "medal": Medal,
  "menu": Menu,
  "message-circle-more": MessageCircleMore,
  "message-circle-question": MessageCircleQuestion,
  "message-square-more": MessageSquareMore,
  "message-square-text": MessageSquareText,
  "messages-square": MessagesSquare,
  "mic-off": MicOff,
  "minus": Minus,
  "moon": Moon,
  "network": Network,
  "newspaper": Newspaper,
  "paperclip": Paperclip,
  "pen": Pen,
  "pen-line": PenLine,
  "pencil": Pencil,
  "phone": Phone,
  "phone-off": PhoneOff,
  "pie-chart": PieChart,
  "plane": Plane,
  "play": Play,
  "play-circle": PlayCircle,
  "plus": Plus,
  "presentation": Presentation,
  "radar": Radar,
  "redo": Redo,
  "refresh-cw": RefreshCw,
  "reply": Reply,
  "reply-all": ReplyAll,
  "rocket": Rocket,
  "save": Save,
  "scroll-text": ScrollText,
  "search": Search,
  "send": Send,
  "share": Share,
  "share-2": Share2,
  "shield": Shield,
  "shopping-bag": ShoppingBag,
  "shopping-cart": ShoppingCart,
  "signal": Signal,
  "sliders-horizontal": SlidersHorizontal,
  "smile": Smile,
  "sparkles": Sparkles,
  "square": Square,
  "square-check": SquareCheck,
  "square-check-big": SquareCheckBig,
  "square-code": SquareCode,
  "square-minus": SquareMinus,
  "square-pen": SquarePen,
  "square-plus": SquarePlus,
  "square-x": SquareX,
  "star": Star,
  "star-half": StarHalf,
  "stethoscope": Stethoscope,
  "sticky-note": StickyNote,
  "store": Store,
  "sun": Sun,
  "table": Table,
  "tag": Tag,
  "tags": Tags,
  "thumbs-down": ThumbsDown,
  "thumbs-up": ThumbsUp,
  "ticket": Ticket,
  "trash": Trash,
  "trash-2": Trash2,
  "triangle-alert": TriangleAlert,
  "trophy": Trophy,
  "truck": Truck,
  "underline": Underline,
  "undo": Undo,
  "university": University,
  "upload": Upload,
  "user": User,
  "user-check": UserCheck,
  "user-cog": UserCog,
  "user-pen": UserPen,
  "user-round-cog": UserRoundCog,
  "user-round-minus": UserRoundMinus,
  "user-round-plus": UserRoundPlus,
  "user-round-x": UserRoundX,
  "users": Users,
  "video": Video,
  "video-off": VideoOff,
  "wallet": Wallet,
  "wand-sparkles": WandSparkles,
  "wifi": Wifi,
  "x": X,
  "zoom-in": ZoomIn,
  "zoom-out": ZoomOut,
};

export function getStaticLucideIcon(name: string): LucideIcon {
  return STATIC_LUCIDE_ICONS[name] ?? Circle;
}
